import { selectors as brandSelectors } from "../brand";

export function isFeedbackExternal(state) {
  return !!brandSelectors.getBrandValue(state, "Feedback.library_url");
}
